import styled from "styled-components";

export default function BottomBar() {
  return (
    <Container>
      <p>&copy; Copyright 2023 Bergson Corporation</p>
    </Container>
  );
}

const Container = styled.div`
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  color: #ffffff;
  text-align: center;
`;
